module.exports = __webpack_public_path__ + "static/media/science.d899fd26.png";